import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIdSymbol = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M29 11C30.105 11 31 11.895 31 13V26C31 27.105 30.105 28 29 28H11C9.895 28 9 27.105 9 26V13C9 11.895 9.895 11 11 11H29Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 24L15 16",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4941 25H17.8848V14.8182H21.524C22.5481 14.8182 23.4297 15.022 24.1689 15.4297C24.908 15.834 25.4764 16.4157 25.8741 17.1747C26.2752 17.9337 26.4757 18.8419 26.4757 19.8991C26.4757 20.9597 26.2752 21.8712 25.8741 22.6335C25.4764 23.3958 24.9047 23.9808 24.1589 24.3885C23.4165 24.7962 22.5282 25 21.4941 25ZM20.0375 23.1555H21.4047C22.041 23.1555 22.5763 23.0428 23.0105 22.8175C23.448 22.5888 23.7761 22.2358 23.9949 21.7585C24.2169 21.2779 24.3279 20.6581 24.3279 19.8991C24.3279 19.1468 24.2169 18.532 23.9949 18.0547C23.7761 17.5774 23.4496 17.2261 23.0154 17.0007C22.5813 16.7753 22.046 16.6626 21.4096 16.6626H20.0375V23.1555Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgIdSymbol);
export default ForwardRef;
